<template>
  <div class="modal_wrapper">
    <div class="container">
      <div class="modal_container">
        <div class="modal_header">
          {{ title }}
        </div>
        <div class="modal_body">
          <div class="body">
            <div>{{ selectJobs }}</div>
            <div class="table">
              <table
                class="table_header"
                border="1"
                cellpadding="2"
                bordercolor="#fff"
                style="border-collapse: collapse"
              >
                <tr>
                  <th class="table_first_child post_table_header_first_padding">
                    <input
                      type="checkbox"
                      class="checkbox"
                      :checked="checked"
                      @click="allCheckedAction"
                    />
                  </th>
                  <th class="post_table_content" align="left">
                    {{ job }}
                  </th>
                </tr>
              </table>

              <div class="edit_table_contents">
                <table
                  class="edit_table_content"
                  border="1"
                  cellpadding="2"
                  bordercolor="#fff"
                  style="border-collapse: collapse"
                >
                  <tr class="table_row" v-for="job in jobs" :key="job.job">
                    <td class="table_first_child">
                      <input
                        type="checkbox"
                        class="checkbox"
                        v-model="job.checked"
                      />
                    </td>
                    <td class="post_table_content">
                      {{ job.job }}
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
          <div class="modal_buttons">
            <input
              type="button"
              :value="closeButton"
              class="cancel_button"
              @click="$emit('close')"
            />
            <input
              v-if="!jobs.some((job) => job.checked)"
              type="button"
              :value="okButton"
              class="finish_button disabled"
            />
            <input
              v-if="jobs.some((job) => job.checked)"
              type="button"
              :value="okButton"
              class="finish_button"
              @click="exportJobList"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      title: 'ケアワーカーエクスポート',
      selectJobs: 'エクスポートする職種を選択してください。',
      job: '職種',
      closeButton: 'キャンセル',
      okButton: 'OK',
      checked: false
    }
  },
  computed: {
    jobs() {
      return this.$store.state.careworkers.jobs
    }
  },
  methods: {
    allCheckedAction(e) {
      // リストのチェックボックスを全てチェックする。
      this.checked = !this.checked
      for (let i = 0; i < this.jobs.length; i++) {
        this.jobs[i].checked = this.checked
      }
    },
    exportJobList(e) {
      let exportJobList = this.jobs
        .map((job) => {
          if (job.checked) {
            return {job: job.job}
          }
        })
        .filter(Boolean)
      this.$emit('export', exportJobList)
    }
  }
}
</script>
<style scoped>
.modal_wrapper {
  background-color: rgba(0, 0, 0, 0.5);
}
.container {
  display: table-cell;
  vertical-align: middle;
}
.modal_container {
  height: 385px;
  width: 635px;
}
.modal_body {
  height: 337px;
}
.body {
  width: 100%;
  height: 229px;
  padding-top: 40px;
  /* IEでスクロールバーを隠す */
  -ms-overflow-style: none;
}
table {
  width: 100%;
}
.modal_header {
  display: flex;
  align-items: center;
  padding-left: 20px;
}
.disabled {
  background-color: #afafaf;
}
</style>



// WEBPACK FOOTER //
// src/components/modalWindow/selectExportJobsModalWindow.vue